"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATION_TYPE = void 0;
exports.NOTIFICATION_TYPE = {
    ROLE_UPDATED: {
        id: 1,
        name: 'notification_role_updated',
    },
    CONTACT_METHOD_UPDATED: {
        id: 2,
        name: 'notification_contact_method_updated',
    },
    WORK_ORDER_CREATED: {
        id: 3,
        name: 'notification_work_order_created',
    },
    WORK_ORDER_UPDATED: {
        id: 4,
        name: 'notification_work_order_updated',
    },
    WORK_ORDER_ASSIGNED: {
        id: 5,
        name: 'notification_work_order_assigned',
    },
    WORK_ORDER_DELETED: {
        id: 6,
        name: 'notification_work_order_deleted',
    },
    PROPERTY_CREATED: {
        id: 7,
        name: 'notification_property_created',
    },
    PROPERTY_UPDATED: {
        id: 8,
        name: 'notification_property_updated',
    },
    PROPERTY_DELETED: {
        id: 9,
        name: 'notification_property_deleted',
    },
    USER_ADDED_TO_PROPERTY: {
        id: 10,
        name: 'notification_user_added_to_property',
    },
    USER_REMOVED_FROM_PROPERTY: {
        id: 11,
        name: 'notification_user_removed_from_property',
    },
    WORK_ORDER_ATTACHMENT_CREATED: {
        id: 12,
        name: 'notification_work_order_attachment_created',
    },
    WORK_ORDER_ATTACHMENT_DELETED: {
        id: 13,
        name: 'notification_work_order_attachment_deleted',
    },
    WORK_ORDER_COMMENT_CREATED: {
        id: 14,
        name: 'notification_work_order_comment_created',
    },
    WORK_ORDER_WATCHER_CREATED: {
        id: 15,
        name: 'notification_work_order_watcher_created',
    },
    WORK_ORDER_WATCHER_DELETED: {
        id: 16,
        name: 'notification_work_order_watcher_deleted',
    },
    WORK_ORDER_UNASSIGNED: {
        id: 17,
        name: 'notification_work_order_unassigned',
    },
    WORK_ORDER_OVERDUE: {
        id: 18,
        name: 'notification_work_order_overdue',
    },
    NO_WORK_ORDER_CREATED: {
        id: 19,
        name: 'notification_no_work_order_created',
    },
    WORK_ORDER_BID_PUBLISHED: {
        id: 20,
        name: 'notification_work_order_bid_published',
    },
};
//# sourceMappingURL=notification.types.js.map